import { render, staticRenderFns } from "./CandidateView.vue?vue&type=template&id=a5839ee8"
import script from "./CandidateView.vue?vue&type=script&lang=js"
export * from "./CandidateView.vue?vue&type=script&lang=js"
import style0 from "./CandidateView.vue?vue&type=style&index=0&id=a5839ee8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports